// extracted by mini-css-extract-plugin
export default {"label":"Vvtn5","variantSelectorContainer":"C09ug","sizingHelp":"NWSPy"};